module.exports = __webpack_public_path__ + "static/media/checkmark-black.f50b6c37.svg";